var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6673 29.3335L14.0007 21.3335H3.33398L6.00065 29.3335H16.6673ZM16.6673 29.3335H22.0006",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 17.3335V16.6668C16.6667 14.1527 16.6667 12.8956 15.8856 12.1145C15.1045 11.3335 13.8475 11.3335 11.3333 11.3335C8.81917 11.3335 7.56209 11.3335 6.78105 12.1145C6 12.8956 6 14.1527 6 16.6668V17.3335",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0003 17.3332C26.0003 18.806 24.8065 19.9998 23.3337 19.9998C21.8609 19.9998 20.667 18.806 20.667 17.3332C20.667 15.8604 21.8609 14.6665 23.3337 14.6665C24.8065 14.6665 26.0003 15.8604 26.0003 17.3332Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 5.33317C14.0003 6.80593 12.8064 7.99984 11.3337 7.99984C9.8609 7.99984 8.66699 6.80593 8.66699 5.33317C8.66699 3.86041 9.8609 2.6665 11.3337 2.6665C12.8064 2.6665 14.0003 3.86041 14.0003 5.33317Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.334 23.3335H27.334C28.8068 23.3335 30.0007 24.5274 30.0007 26.0002V26.6668C30.0007 28.1396 28.8068 29.3335 27.334 29.3335H26.0007",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame16);
export default __webpack_public_path__ + "static/media/Frame (16).be26cb6237d71d836b81d4868dda8933.svg";
export { ForwardRef as ReactComponent };